module.exports = __webpack_public_path__ + "static/media/speakers_logos_Harbin.6b575a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Harbin.jpg
// module id = 267
// module chunks = 0